/* Real CSD schools */
export const SCHOOLS = [
  "Clairemont Elementary",
  "College Heights Early Childhood Learning Center",
  "Glennwood Elementary",
  "Oakhurst Elementary",
  "Talley Street Upper Elementary",
  "Beacon Hill Middle School (BHMS)",
  "Decatur High School",
  "Fifth Avenue Upper Elementary",
  "Westchester Elementary",
  "Winnona Park Elementary",
];

export const SENIOR_CATEGORIES = [
  "2026 Senior",
];

export const ALL_SCHOOL_OPTIONS = [...SCHOOLS, ...SENIOR_CATEGORIES];
